import { t } from "@travily/i18n";
import type AccountByline from "@travily/types/models/AccountByline";
import type { AccountBylineBioTrait, AccountBylineProfileLinkTrait } from "@travily/types/models/AccountByline";
import { Heading } from "@ui/components/Heading";
import { Link } from "@ui/primitives/Link";
import { AccountAvatar } from "@/components/AccountAvatar/AccountAvatar";

/** Displays the product creator's avatar, name and bio, linked to their profile when they hold one. */
export type CreatorProps = AccountByline & AccountBylineBioTrait & AccountBylineProfileLinkTrait;

export function Creator(props: CreatorProps) {
  const { display_name, bio, profile_url } = props;

  const identity = (
    <>
      <AccountAvatar account={props} className="lg:hidden" shape="square" size="100" />
      <AccountAvatar account={props} className="hidden lg:flex" shape="square" size="140" />
      <div className="flex min-w-0 flex-1 flex-col gap-1 self-stretch">
        <p className="text-lg font-semibold leading-6 text-neutral-900 lg:text-xl lg:leading-7">{display_name}</p>
        {bio && (
          <p className="whitespace-pre-line text-sm leading-5 text-neutral-600 lg:text-base lg:leading-6">{bio}</p>
        )}
      </div>
    </>
  );

  return (
    <div className="mt-6 flex flex-col gap-3 lg:mt-8 lg:gap-5">
      <Heading.Root color="primary" divider="end" size="sm">
        <Heading.Title>{t("components.views.products.creator.title")}</Heading.Title>
      </Heading.Root>
      {profile_url ? (
        <Link className="flex gap-4 lg:gap-6" href={profile_url}>
          {identity}
        </Link>
      ) : (
        <div className="flex gap-4 lg:gap-6">{identity}</div>
      )}
    </div>
  );
}
